<filter-link onclick={event => onClick(event)} href="#">
  <slot />

  <script>
    import {Url} from '@wendig/lib'

    export default class {
      onClick(event) {
        event.preventDefault()

        this.toggle()
      }

      toggle() {
        const {name, value} = this.props

        const url = Url.current()
        let values = url.hashParams()[name]?.split('|') || []

        const i = values.indexOf(value)
        if (i == -1) values.push(value)
        else values.splice(i, 1)
        url.updateHashParams({[name]: values.join('|')})
        url.apply()
      }
    }
  </script>
</filter-link>
